import React, { useMemo, useState } from 'react';
import css from './FilterSidebar.module.css';
import { divisionOptions } from '../../../config/configExtras';
import SearchInput from './SearchInput';
import FilterSectionHeader from './FilterSectionHeader';
import classNames from 'classnames';

const DivisionFilterSection = ({
  handleClearFilter,
  handleCheckboxChange,
  selectedValues,
  paramKey,
  isBlackBgFilter,
  isTalentOfferingFilters,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  // Memoized filtering for performance
  const filteredDivisionOptions = useMemo(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return divisionOptions.filter(({ key }) => key.toLowerCase().includes(lowerSearchTerm));
  }, [searchTerm, divisionOptions]);

  const displayedDivisionOptions = filteredDivisionOptions.slice(0, 10);
  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };
  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <FilterSectionHeader
          isBlackBgFilter={isBlackBgFilter}
          titleId={'FilterCategories.division'}
          handleClear={handleClear}
        />
      )}
      <SearchInput
        placeholder="Search Division..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />

      <div className={css.scrollable}>
        {displayedDivisionOptions.map(option => {
          // Ensure the key comparison is case-insensitive
          const optionKey = option.key;
          const isChecked = selectedValues.includes(optionKey);
          return (
            <label key={option.key} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={optionKey}
                checked={isChecked}
                onChange={e => handleCheckboxChange(e, paramKey)}
                name="division"
              />
              <span>{option.value}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default DivisionFilterSection;
